import './OfferCard.scss';

/*
  Redesigned offer/benefit tile, converted from the offer-listing.html
  mockup. Pluggable, self-contained component: all CSS is scoped under
  ".oc-card" with "oc-" prefixed classes, same approach as
  GiveawayDetailsStatic, so it can be dropped into any listing grid
  without colliding with existing global styles.

  Renders benefit.shortDescription (short teaser) - NOT benefit.description,
  which is the full write-up reserved for the offer details page only.

  When benefit.isOffline is set (store-only benefit, redeemed in person at the
  partner's outlet) the tile shows benefit.offerText - a plain summary such as
  "10% Off on all" - in place of the offerCode chip. Visit Website still
  appears when the partner has a website.

  The defaults are the logged-in dashboard listing. The public /Offers page
  reuses the same tile with showCode/showWebsite off (nothing redeemable is
  given away to signed-out visitors) and its own sign-up call to action.
*/

const OfferCard = ({
  benefit,
  getOfferHref,
  visitWebsiteHref,
  ctaLabel = 'Details',
  ctaIcon,
  onOfferClick,
  showCode = true,
  showWebsite,
}) => {
  const assetUrl = process.env.REACT_APP_TAURIAN_ASSET_URL;

  const offerHref = getOfferHref || `/dashboard/offers/${benefit?.id}`;
  const websiteHref = visitWebsiteHref || benefit?.partner?.website;
  const shortDescription = benefit?.shortDescription || benefit?.description;

  // Store-only benefits are redeemed in person, so they show offerText instead
  // of a coupon code. The partner website is still a valid next step.
  const isOffline = Boolean(benefit?.isOffline);
  const canShowWebsite = showWebsite !== false && Boolean(websiteHref);

  const ctaContent = (
    <>
      {ctaIcon && <i className={`${ctaIcon} oc-btn-icon`} />}
      {ctaLabel}
    </>
  );

  return (
    <div className="oc-card">
      <div className="oc-img">
        {benefit?.category && <span className="oc-category">{benefit.category}</span>}
        <img src={`${assetUrl}${benefit?.images?.[0]}`} alt={benefit?.name || ''} />
      </div>

      <div className="oc-body">
        <h3>{benefit?.name}</h3>

        {shortDescription && <p className="oc-short-desc">{shortDescription}</p>}

        {showCode && (isOffline
          ? benefit?.offerText && (
              <span className="oc-code oc-offer-text">{benefit.offerText}</span>
            )
          : benefit?.offerCode && (
              <span className="oc-code"><i className="fa-solid fa-ticket" /> {benefit.offerCode}</span>
            ))}

        <div className="oc-actions">
          {onOfferClick
            ? (
              <button type="button" className="oc-btn-primary" onClick={() => onOfferClick(benefit)}>
                {ctaContent}
              </button>
            )
            : <a className="oc-btn-primary" href={offerHref}>{ctaContent}</a>}
          {canShowWebsite && (
            <a className="oc-btn-secondary" href={websiteHref} target="_blank" rel="noopener noreferrer">Visit Website</a>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
